var map = {
	"./aperitif-blue.svg": 1307,
	"./apero-blue.svg": 8432,
	"./arrow-blue.svg": 442,
	"./cadeau-blue.svg": 9520,
	"./cheese-blue.svg": 815,
	"./dessert-blue.svg": 7569,
	"./fish-blue.svg": 9033,
	"./fresh-blue.svg": 9925,
	"./fruity-blue.svg": 7494,
	"./meat-blue.svg": 4510,
	"./occasion-blue.svg": 43,
	"./round-blue.svg": 1667,
	"./spicy-blue.svg": 7133,
	"./surprise-blue.svg": 777,
	"./vege-blue.svg": 2343
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84;